<template>
  <div>
    <Combobox
      v-model="field"
      :options="options.map(option => ({
        value: option.type,
        label: option.name,
        disabled: option.disabled
      }))"
      :fullwidth="true"
    />

    <div v-if="fieldSelected?.options?.length > 0" class="form-group">
      <Combobox
        v-model="extrafieldValue"
        :options="fieldSelected.options.map(option => ({
          value: option.id,
          label: option.name,
          disabled: option.disabled
        }))"
        :fullwidth="true"
      />
    </div>
  </div>
</template>

<script>
import Combobox from "@/components/ui/Combobox.vue";

export default {
  components: {
    Combobox
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      default: null
    },
  },
  data() {
    return {
      field: this.modelValue?.field || null,
      extrafieldValue: this.modelValue?.value || null,
    }
  },
  computed: {
    fieldSelected: function () {
      return this.options.find(option => option.type === this.field)
    }
  },
  watch: {
    field: function () {
      if (!this.fieldSelected) {
        this.$emit('update:modelValue', null)
      } else if (this.fieldSelected.options?.length > 0 && !this.extrafieldValue) {
        this.$emit('update:modelValue', null)
      } else {
        this.$emit('update:modelValue', {
          field: this.fieldSelected.type,
        })
      }
    },
    extrafieldValue: function (val) {
      if (!val) {
        this.$emit('update:modelValue', null)
      } else {
        this.$emit('update:modelValue', {
          field: this.fieldSelected.type,
          value: val
        })
      }
    },
/*    value: function (val) {
      this.field = val?.field || null;
      this.$nextTick(() => {
        this.extrafieldValue = val?.value || null;
      })
    }*/
  }
}
</script>
